import React from 'react';

import { Icon } from '../../shared/icon/Icon';
import { Document } from '../../shared/icons';
import { TooltipList } from '../../shared/tooltip';

interface HiddenDocumentsTooltipProps {
    hiddenDocumentNames: string[];
    fieldType: string;
}

export const HiddenDocumentsTooltip: React.FC<HiddenDocumentsTooltipProps> = ({ hiddenDocumentNames, fieldType }) => (
    <TooltipList overlayText={hiddenDocumentNames} placement='right' listHeader={`This ${fieldType} is not included for the following documents:`}>
        <div>
            <Icon icon={Document} fontSize={20} />
        </div>
    </TooltipList>
);
